"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RatesData;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _axios = _interopRequireDefault(require("axios"));
var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));
var _PulseLoader = _interopRequireDefault(require("react-spinners/PulseLoader"));
var _react2 = require("@emotion/react");
var _reactRedux = require("react-redux");
var _actions = require("../store/actions");
var _applynow = require("applynow");
var _ThemeConfig = _interopRequireDefault(require("../modules/ThemeConfig"));
var _PriceForState = _interopRequireDefault(require("../modules/PriceForState"));
var _usersession = require("usersession");
var _templateObject;
/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
/* eslint-disable eqeqeq */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
// import { useRatesContext } from "../context/ratesContext";

// const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop, {behavior: 'smooth'})
// General scroll to element function

function RatesData(props) {
  // const {
  //   state,
  //   countryStateUpdate,
  //   DownPaymentInUSDsUpdate,
  //   stateCountyUpdate,
  // } = useRatesContext();
  const userSession = new _usersession.UserSession();
  const themeConfig = new _ThemeConfig.default(props);
  const priceForStateConfig = new _PriceForState.default(userSession.getPropertyState());
  let themeLeadSource, themePromoCode, themeUserId, themeBranchCode, themeLockPeriod, themeMatchExactPrice, themeScenarios;
  if (themeConfig.requestRates.purchase) {
    themeLeadSource = themeConfig.requestRates.purchase.leadSource;
    themePromoCode = themeConfig.requestRates.purchase.promoCode;
    themeUserId = themeConfig.requestRates.purchase.userId;
    themeBranchCode = themeConfig.requestRates.purchase.branch;
    themeLockPeriod = themeConfig.requestRates.purchase.lockPeriod;
    themeMatchExactPrice = themeConfig.requestRates.purchase.matchExactPrice;
    themeScenarios = themeConfig.requestRates.purchase.scenarios;
  } else if (themeConfig.requestRates.refinance) {
    themeLeadSource = themeConfig.requestRates.refinance.leadSource;
    themePromoCode = themeConfig.requestRates.refinance.promoCode;
    themeUserId = themeConfig.requestRates.refinance.userId;
    themeBranchCode = themeConfig.requestRates.refinance.branch;
    themeLockPeriod = themeConfig.requestRates.refinance.lockPeriod;
    themeMatchExactPrice = themeConfig.requestRates.refinance.matchExactPrice;
    themeScenarios = themeConfig.requestRates.refinance.scenarios;
  } else if (themeConfig.requestRates.cashoutrefinance) {
    themeLeadSource = themeConfig.requestRates.cashoutrefinance.leadSource;
    themePromoCode = themeConfig.requestRates.cashoutrefinance.promoCode;
    themeUserId = themeConfig.requestRates.cashoutrefinance.userId;
    themeBranchCode = themeConfig.requestRates.cashoutrefinance.branch;
    themeLockPeriod = themeConfig.requestRates.cashoutrefinance.lockPeriod;
    themeMatchExactPrice = themeConfig.requestRates.cashoutrefinance.matchExactPrice;
    themeScenarios = themeConfig.requestRates.cashoutrefinance.scenarios;
  }
  // Added by Ankita on 02/26/2024 - WEB-566
  else if (themeConfig.requestRates.homeEquity) {
    themeLeadSource = themeConfig.requestRates.homeEquity.leadSource;
    themePromoCode = themeConfig.requestRates.homeEquity.promoCode;
    themeUserId = themeConfig.requestRates.homeEquity.userId;
    themeBranchCode = themeConfig.requestRates.homeEquity.branch;
    themeLockPeriod = themeConfig.requestRates.homeEquity.lockPeriod;
    themeMatchExactPrice = themeConfig.requestRates.homeEquity.matchExactPrice;
    themeScenarios = themeConfig.requestRates.homeEquity.scenarios;
  }
  const [loading, setLoading] = (0, _react.useState)(false);
  // const [noCCProgram, setNoCCProgram] = useState(false);

  const [loanTypeName, setLoanTypeName] = (0, _react.useState)("");
  const [countyName, setCountyName] = (0, _react.useState)("");
  const [countyCode, setCountyCode] = (0, _react.useState)("");
  const [propTypeName, setPropTypeName] = (0, _react.useState)("");
  const [propUsed, setPropUsed] = (0, _react.useState)("");
  const [ltv, setLtv] = (0, _react.useState)(0);
  const todayDate = new Date(); //Today date
  const shortDate = new Intl.DateTimeFormat("en-US").format(todayDate);
  const myRefRD = (0, _react.useRef)(null);
  const [productsList, setProductsList] = (0, _react.useState)([]);
  const dispatch = (0, _reactRedux.useDispatch)();
  const [tabKey, setTabKey] = (0, _react.useState)(localStorage.getItem("checkedTab") !== "" ? localStorage.getItem("checkedTab") : "conventional");
  const override = (0, _react2.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    padding: 45px;\n    justify-content: center;\n  "])));
  /*06-27-2020 Jay Binod Singh WEB-45 Added below section to call api and assign and display on response
      for Conventinal/FHA/VAJBS Rate data
      Added below till line 83 to call API and store data to display on page same as landing page
      */
  const [showCvnRates, setCvnRates] = (0, _react.useState)(true);
  const [showFHARates, setFHARates] = (0, _react.useState)(false);
  const [showVARates, setVARates] = (0, _react.useState)(false);
  const [showUsdaRates, setUsdaRates] = (0, _react.useState)(false);
  const [showHomeEquity2ndTDRates, setHomeEquity2ndTDRates] = (0, _react.useState)(true); //Added by Ankita Porwal - WEB-566
  const show = true;
  // const [show, setShow] = useState(true); //  -----------> Currently hard coded to show the Rates section by default
  /* States to set the received data from Pricing */
  const [conv15A, setConv15A] = (0, _react.useState)("");
  const [conv30A, setConv30A] = (0, _react.useState)("");
  const [fha15A, setFha15A] = (0, _react.useState)("");
  const [fha30A, setFha30A] = (0, _react.useState)("");
  const [va15A, setVa15A] = (0, _react.useState)("");
  const [va30A, setVa30A] = (0, _react.useState)("");
  const [usda15A, setUsda15A] = (0, _react.useState)("");
  const [usda30A, setUsda30A] = (0, _react.useState)("");
  const [homeEquity2NDTD15A, setHomeEquity2NDTD15A] = (0, _react.useState)(""); //Added by Ankita Porwal - WEB-566
  const [homeEquity2NDTD30A, setHomeEquity2NDTD30A] = (0, _react.useState)(""); //Added by Ankita Porwal - WEB-566
  const [defaultTab, setDefaultTab] = (0, _react.useState)("");

  /*
    Dennis, right now the implementation is not generic. This is not how I wanted it implemented
     */

  const handleResultsProdTabs = key => {
    setTabKey(key);
    if (key == "conventional") {
      setCvnRates(true);
      setFHARates(false);
      setVARates(false);
      setUsdaRates(false);
      setHomeEquity2ndTDRates(false);
      localStorage.setItem("checkedTab", "conventional");
    } else if (key == "fha") {
      setCvnRates(false);
      setFHARates(true);
      setVARates(false);
      setUsdaRates(false);
      setHomeEquity2ndTDRates(false);
      localStorage.setItem("checkedTab", "fha");
    } else if (key == "va") {
      setCvnRates(false);
      setFHARates(false);
      setVARates(true);
      setUsdaRates(false);
      setHomeEquity2ndTDRates(false);
      localStorage.setItem("checkedTab", "va");
    } else if (key === "usda") {
      setCvnRates(false);
      setFHARates(false);
      setVARates(false);
      setUsdaRates(true);
      setHomeEquity2ndTDRates(false);
      localStorage.setItem("checkedTab", "usda");
    } else if (key === "homeEquity") {
      setCvnRates(false);
      setFHARates(false);
      setVARates(false);
      setUsdaRates(false);
      setHomeEquity2ndTDRates(true);
      localStorage.setItem("checkedTab", "homeEquity");
    }
  };
  /* End of States to set the received data from Pricing */

  (0, _react.useEffect)(() => {
    let loanAmount = "";
    // Set the no closing cost variable
    // setNoCCProgram(
    //   themeLeadSource == "NET007" || themeLeadSource == "NET021" ? false : userSession.getNoClosingCosts()
    // );

    if (userSession.getPurchasePrice() == 0) {
      dispatch((0, _actions.DownPaymentInUSDsUpdate)(0));
      userSession.setDownPaymentAmount(0);
    }
    let zipCode = userSession.getPropertyZipCode();
    if (zipCode.length == 5) {
      setLoading(true);
      _axios.default.get(process.env.REACT_APP_SUNSOFT_RESTSERVER_ZIPCODE + zipCode, "", {
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        setCountyName(response.data.counties[0].name);
        setCountyCode(response.data.counties[0].code);
        userSession.setPropertyCounty(response.data.counties[0].code);
        dispatch((0, _actions.stateCountyUpdate)(response.data.counties[0].code));
        userSession.setPropertyState(response.data.state);
        dispatch((0, _actions.countryStateUpdate)(response.data.state));
      });
    }
    if (zipCode.length < 5) {
      _axios.default.get(process.env.REACT_APP_SUNSOFT_RESTSERVER_STATE_COUNTY_PUBLIC + userSession.getPropertyCounty(), {
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        setCountyName(response.data.countyName);
      });
    }
    // Below switch statement set the loan type name that in the no match product table
    switch (userSession.getLoanPurpose()) {
      case "0":
        setLoanTypeName("Purchase");
        break;
      case "1":
        setLoanTypeName("Refinance");
        break;
      case "2":
        setLoanTypeName("Cash Out Refi");
        break;
      //no default
    }
    // Below switch statement set the property type name in the no match product table
    switch (userSession.getPropertyType()) {
      case "SFR":
        setPropTypeName("Single Family");
        break;
      case "CONDO":
        setPropTypeName("Condo");
        break;
      case "MANUFACTURED":
        setPropTypeName("Manufactured Home");
        break;
      case "DUPLEX":
        setPropTypeName("Duplex (2 UNITS)");
        break;
      case "TRIPLEX":
        setPropTypeName("Triplex (3 UNITS)");
        break;
      case "FOURPLEX":
        setPropTypeName("Quadplex (4 UNITS)");
        break;
      //no default
    }

    // Below switch statement set the occupancy in the no match product table
    switch (userSession.getPropertyUse()) {
      case "1":
        setPropUsed("Primary Home");
        break;
      case "2":
        setPropUsed("Investment Property");
        break;
      case "3":
        setPropUsed("Secondary Home");
        break;
      //no default
    }

    // Set loan to value
    if (userSession.getLoanPurpose() == "0") {
      loanAmount = Number(userSession.getPurchasePrice()) - Number(userSession.getDownPaymentAmount());
      setLtv(loanAmount / userSession.getPurchasePrice());
    }
    if (userSession.getLoanPurpose() == "1" || userSession.getLoanPurpose() == "2") {
      loanAmount = Number(userSession.getCurrentLoanBalance()) + Number(userSession.getCashOutAmount());
      let loanLtv = Number(userSession.getCurrentLoanBalance()) / Number(userSession.getEstimatedValue());
      setLtv(loanLtv);
    }
    setLoading(true);
    let requestBody = {
      loanAmount: loanAmount > 0 ? loanAmount : "",
      loanPurpose: userSession.getLoanPurpose(),
      downPayment: userSession.getDownPaymentAmount(),
      propertyValue: userSession.getPurchasePrice() > 0 ? userSession.getPurchasePrice() : userSession.getEstimatedValue(),
      currentLoanBalance: userSession.getCurrentLoanBalance(),
      propertyTypeKeyword: userSession.getPropertyType(),
      occupancy: userSession.getPropertyUse(),
      propertyState: userSession.getPropertyState(),
      propertyCounty: userSession.getPropertyCounty() !== "" ? userSession.getPropertyCounty() : countyCode,
      propertyZipCode: userSession.getPropertyZipCode(),
      creditScore: userSession.getCreditScore(),
      price: userSession.getNoClosingCosts() == "true" && themeLeadSource !== "NET007" ? priceForStateConfig.getPriceForState() : 100,
      veteran: userSession.getVeteran(),
      leadSource: themeLeadSource,
      promoCode: themePromoCode,
      userId: themeUserId,
      branchCode: themeBranchCode,
      lockPeriod: themeLockPeriod,
      matchExactPrice: userSession.getNoClosingCosts() == "false" ? true : themeMatchExactPrice,
      scenarios: themeScenarios
    };

    // Add home equity scenarios to request body
    if (userSession.getLoanPurpose() == 2) {
      themeScenarios = "".concat(themeScenarios, ",").concat(themeConfig.requestRates.homeEquity.scenarios);
      requestBody.scenarios = themeScenarios;
      requestBody.documentType = themeConfig.requestRates.homeEquity.documentType;
      requestBody.immigrationStatus = themeConfig.requestRates.homeEquity.immigrationStatus;
    }
    _axios.default.post(process.env.REACT_APP_SUNSOFT_API_PRICE_SCENARIO_, requestBody, {
      headers: {
        "Content-Type": "application/json"
      }
    }).then(response => {
      let parDataResponse = response.data;
      let parDataReqBody = requestBody;
      parDataReqBody.userId = props.loID ? props.loID : themeUserId;
      parDataReqBody.matchExactPrice = false;
      //get close to par data response
      _axios.default.post(process.env.REACT_APP_SUNSOFT_API_PRICE_SCENARIO_, parDataReqBody, {
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        let closeToParDataResponse = response.data;
        if (parDataResponse && closeToParDataResponse) {
          // from the response get all the products that are a match
          // productList  contains the list of products that came on the response for which we have a match
          Object.keys(parDataResponse).forEach(function (key) {
            if (parDataResponse[key].match === true) {
              productsList.push(parDataResponse[key]);
              // 06/30/2020 Dennis, I do not want to do this but for the time been will apply this patch.
              // ideally the U/I should iterate productsList and render the products dynamically.
              // I am just following what was implemented to get this out quick.
              switch (parDataResponse[key].loanType.toUpperCase()) {
                case "CONVENTIONAL":
                  parDataResponse[key].amortTerm = parDataResponse[key].loanTerm;
                  switch (parDataResponse[key].loanTerm) {
                    case 15:
                      setConv15A(parDataResponse[key]);
                      break;
                    case 30:
                      setConv30A(parDataResponse[key]);
                      break;
                    // no default
                  }
                  break;
                case "FHA":
                  parDataResponse[key].amortTerm = parDataResponse[key].loanTerm;
                  switch (parDataResponse[key].loanTerm) {
                    case 15:
                      setFha15A(parDataResponse[key]);
                      break;
                    case 30:
                      setFha30A(parDataResponse[key]);
                      break;
                    // no default
                  }
                  break;
                case "VA":
                  parDataResponse[key].amortTerm = parDataResponse[key].loanTerm;
                  switch (parDataResponse[key].loanTerm) {
                    case 15:
                      setVa15A(parDataResponse[key]);
                      break;
                    case 30:
                      setVa30A(parDataResponse[key]);
                      break;
                    // no default
                  }
                  break;
                // no default
                case "USDA":
                  parDataResponse[key].amortTerm = parDataResponse[key].loanTerm;
                  switch (parDataResponse[key].loanTerm) {
                    case 15:
                      setUsda15A(parDataResponse[key]);
                      break;
                    case 30:
                      setUsda30A(parDataResponse[key]);
                      break;
                    // no default
                  }
                  break;
                // no default
              }
              console.log("tabKey: " + tabKey);
              if (!tabKey) {
                // This condition is to show the correct rate tab after the first submit.
                setDefaultTab(Object.values(parDataResponse)[0].loanType.toLowerCase());
                handleResultsProdTabs(Object.values(parDataResponse)[0].loanType.toLowerCase());
              }
            }
            // from the response get all the products that are a close to par
            // productList contains the list of products that came on the response for which we have a received par price
            else if (closeToParDataResponse[key].match === true) {
              //console.log("else: " + closeToParDataResponse[key]);
              productsList.push(closeToParDataResponse[key]);
              // 06/30/2020 Dennis, I do not want to do this but for the time been will apply this patch.
              // ideally the U/I should iterate productsList and render the products dynamically.
              // I am just following what was implemented to get this out quick.
              switch (closeToParDataResponse[key].loanType.toUpperCase()) {
                case "CONVENTIONAL":
                  closeToParDataResponse[key].amortTerm = closeToParDataResponse[key].loanTerm;
                  switch (closeToParDataResponse[key].loanTerm) {
                    case 15:
                      setConv15A(closeToParDataResponse[key]);
                      break;
                    case 30:
                      setConv30A(closeToParDataResponse[key]);
                      break;
                    // no default
                  }
                  break;
                case "FHA":
                  closeToParDataResponse[key].amortTerm = closeToParDataResponse[key].loanTerm;
                  switch (closeToParDataResponse[key].loanTerm) {
                    case 15:
                      setFha15A(closeToParDataResponse[key]);
                      break;
                    case 30:
                      setFha30A(closeToParDataResponse[key]);
                      break;
                    // no default
                  }
                  break;
                case "VA":
                  closeToParDataResponse[key].amortTerm = closeToParDataResponse[key].loanTerm;
                  switch (closeToParDataResponse[key].loanTerm) {
                    case 15:
                      setVa15A(closeToParDataResponse[key]);
                      break;
                    case 30:
                      setVa30A(closeToParDataResponse[key]);
                      break;
                    // no default
                  }
                  break;
                // no default
                case "USDA":
                  closeToParDataResponse[key].amortTerm = closeToParDataResponse[key].loanTerm;
                  switch (closeToParDataResponse[key].loanTerm) {
                    case 15:
                      setUsda15A(closeToParDataResponse[key]);
                      break;
                    case 30:
                      setUsda30A(closeToParDataResponse[key]);
                      break;
                    // no default
                  }
                  break;
                // no default
                //Added by Ankita - WEB-566
                case "2ND_TD":
                  closeToParDataResponse[key].amortTerm = closeToParDataResponse[key].loanTerm;
                  switch (closeToParDataResponse[key].loanTerm) {
                    case 15:
                      setHomeEquity2NDTD15A(closeToParDataResponse[key]);
                      break;
                    case 30:
                      setHomeEquity2NDTD30A(closeToParDataResponse[key]);
                      break;
                    // no default
                  }
                  break;
              }
              if (!tabKey) {
                // This condition is to show the correct rate tab after the first submit.
                setDefaultTab(Object.values(closeToParDataResponse)[0].loanType.toLowerCase());
                handleResultsProdTabs(Object.values(closeToParDataResponse)[0].loanType.toLowerCase());
              }
            }
            //Added by Ankita - WEB-566
            //As per confirmation from Nai and Dennis Chase, for Home Equity 2nd Td we need to show 15 and 30 amort terms for closeToParDataResponse as in Sunsoft we do not have option to customize the price for 2nd Td.
            if (parDataResponse[key].match === true && closeToParDataResponse[key].match === true) {
              productsList.push(closeToParDataResponse[key]);
              switch (closeToParDataResponse[key].loanType.toUpperCase()) {
                case "2ND_TD":
                  closeToParDataResponse[key].amortTerm = closeToParDataResponse[key].loanTerm;
                  switch (closeToParDataResponse[key].loanTerm) {
                    case 15:
                      setHomeEquity2NDTD15A(closeToParDataResponse[key]);
                      break;
                    case 30:
                      setHomeEquity2NDTD30A(closeToParDataResponse[key]);
                      break;
                    // no default
                  }
                  break;
              }
            }
          });

          // Check if there is previously selected tab saved in the local store.
          if (tabKey) {
            // matchedProduct  contains the list of products loan type that came on the response for which we have a match
            let matchedProduct = productsList.map(product => product.loanType.toLowerCase());

            //Check if the previously selected tab match any loan type n the matchedProduct array
            if (matchedProduct.includes(tabKey)) {
              handleResultsProdTabs(tabKey);
            } else {
              setDefaultTab(Object.values(productsList)[0].loanType.toLowerCase());
              handleResultsProdTabs(Object.values(productsList)[0].loanType.toLowerCase());
            }
          } else {
            // This condition is to show the correct rate tab after the first submit, if there is no tab saved in the local store.
            setDefaultTab(Object.values(productsList)[0].loanType.toLowerCase());
            handleResultsProdTabs(Object.values(productsList)[0].loanType.toLowerCase());
          }

          // sort the products in ascending order (low rates first)
          productsList.sort(function (a, b) {
            return a.rate - b.rate;
          });
          userSession.setWebOffer(JSON.stringify(productsList));
          setProductsList(productsList);
          setLoading(false);
        }
      }).catch(error => {
        setLoading(false);
        console.log(error);
      });
    }).catch(error => {
      setLoading(false);
      console.log(error);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_PulseLoader.default, {
    css: override,
    size: 15,
    color: "#0069d9",
    loading: loading,
    className: "text-center"
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: !loading ? "d-flex justify-content-center" : "d-none"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 12,
    id: "productResult",
    className: "productResult"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    className: "ratesSection"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: !show ? "d-none" : null
  }, productsList.length !== 0 ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tabs, {
    className: "justify-content-center m-auto",
    activeKey: tabKey ? tabKey : defaultTab,
    id: "products-tabs",
    transition: false,
    onSelect: k => handleResultsProdTabs(k)
  }, conv15A || conv30A ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    as: _reactBootstrap.Row,
    className: showCvnRates ? "d-flex justify-content-center convRates" : "d-none convRates",
    eventKey: "conventional",
    title: "Conventional"
  }, conv15A.match === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: conv15A.rate === conv15A.apr || conv15A.apr == 0 ||
    // noCCProgram === true ||
    conv15A.apr - conv15A.rate <= 0.01 ? 3 : 5,
    className: "textBlue poppins-black text-center mb-3 mb-sm-3 mb-lg-0 pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_conv15A",
    leadSource: themeLeadSource,
    data: conv15A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "15 YR FIXED"), conv15A.rate === conv15A.apr || conv15A.apr == 0 ||
  // noCCProgram === true ||
  conv15A.apr - conv15A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: conv15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: conv15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: conv15A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-med pt-0",
    style: {
      fontSize: "1rem"
    }
  }, "(Rate", " ", conv15A.rate === conv15A.apr || conv15A.apr == 0 ||
  // noCCProgram === true ||
  conv15A.apr - conv15A.rate <= 0.01 ? "&" : "/", " ", "APR)"), userSession.getNoClosingCosts() == "true" ? null : /*#__PURE__*/_react.default.createElement("h4", {
    className: conv15A.PI > 0 ? "textBlue poppins-black" : "d-none"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: conv15A.PI,
    displayType: "text",
    prefix: "$",
    thousandSeparator: true,
    decimalScale: 2,
    fixedDecimalScale: true
  }))), conv15A.PI > 0 && userSession.getNoClosingCosts() == "false" ? /*#__PURE__*/_react.default.createElement("h4", {
    style: {
      fontSize: "1rem"
    }
  }, "(Estimated Monthly Payment)") : null, /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource == "NET007" ? "Get Quote" : "Apply Now")))) : null, conv30A.match === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: conv30A.rate === conv30A.apr || conv30A.apr == 0 ||
    // noCCProgram === true ||
    conv30A.apr - conv30A.rate <= 0.01 ? 3 : 5,
    className: "textBlue poppins-black text-center pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_conv30A",
    leadSource: themeLeadSource,
    data: conv30A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "30 YR FIXED"), conv30A.rate === conv30A.apr || conv30A.apr == 0 ||
  // noCCProgram === true ||
  conv30A.apr - conv30A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: conv30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: conv30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: conv30A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-med pt-0",
    style: {
      fontSize: "1rem"
    }
  }, "(Rate", " ", conv30A.rate === conv30A.apr || conv30A.apr == 0 ||
  // noCCProgram === true ||
  conv30A.apr - conv30A.rate <= 0.01 ? "&" : "/", " ", "APR)"), userSession.getNoClosingCosts() == "true" ? null : /*#__PURE__*/_react.default.createElement("h4", {
    className: conv30A.PI > 0 ? "textBlue poppins-black" : "d-none"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: conv30A.PI,
    displayType: "text",
    prefix: "$",
    thousandSeparator: true,
    decimalScale: 2,
    fixedDecimalScale: true
  }))), conv30A.PI > 0 && userSession.getNoClosingCosts() == "false" ? /*#__PURE__*/_react.default.createElement("h4", {
    style: {
      fontSize: "1rem"
    }
  }, "(Estimated Monthly Payment)") : null, /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource == "NET007" ? "Get Quote" : "Apply Now")))) : null) : null, fha15A || fha30A ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    as: _reactBootstrap.Row,
    className: showFHARates ? "d-flex justify-content-center fhaRates" : "d-none fhaRates",
    eventKey: "fha",
    title: "FHA"
  }, fha15A.match === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: fha15A.rate === fha15A.apr || fha15A.apr == 0 || fha15A.apr - fha15A.rate <= 0.01 ? 3 : 5,
    className: "textBlue poppins-black text-center mb-3 mb-sm-3 mb-lg-0 pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_fha15A",
    leadSource: themeLeadSource,
    data: fha15A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "15 YR FIXED"), fha15A.rate === fha15A.apr || fha15A.apr == 0 || fha15A.apr - fha15A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: fha15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: fha15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: fha15A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "fontSizeRateAprText textBlue poppins-med",
    style: {
      fontSize: "1rem"
    }
  }, "(Rate", " ", fha15A.rate === fha15A.apr || fha15A.apr == 0 || fha15A.apr - fha15A.rate <= 0.01 ? "&" : "/", " ", "APR)"), userSession.getNoClosingCosts() == "true" ? null : /*#__PURE__*/_react.default.createElement("h4", {
    className: fha15A.PI > 0 ? "textBlue poppins-black" : "d-none"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: fha15A.PI,
    displayType: "text",
    prefix: "$",
    thousandSeparator: true,
    decimalScale: 2,
    fixedDecimalScale: true
  }))), fha15A.PI > 0 && userSession.getNoClosingCosts() == "false" ? /*#__PURE__*/_react.default.createElement("h4", {
    style: {
      fontSize: "1rem"
    }
  }, "(Estimated Monthly Payment)") : null, /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource == "NET007" ? "Get Quote" : "Apply Now")))) : null, fha30A.match === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: fha30A.rate === fha30A.apr || fha30A.apr == 0 || fha30A.apr - fha30A.rate <= 0.01 ? 3 : 5,
    className: "textBlue poppins-black text-center pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_fha30A",
    leadSource: themeLeadSource,
    data: fha30A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "30 YR FIXED"), fha30A.rate === fha30A.apr || fha30A.apr == 0 || fha30A.apr - fha30A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: fha30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: fha30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: fha30A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "fontSizeRateAprText textBlue poppins-med",
    style: {
      fontSize: "1rem"
    }
  }, "(Rate", " ", fha30A.rate === fha30A.apr || fha30A.apr == 0 || fha30A.apr - fha30A.rate <= 0.01 ? "&" : "/", " ", "APR)"), userSession.getNoClosingCosts() == "true" ? null : /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-black"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: fha30A.PI,
    displayType: "text",
    thousandSeparator: true,
    prefix: "$",
    decimalScale: 2,
    fixedDecimalScale: true
  }))), fha30A.PI > 0 && userSession.getNoClosingCosts() == "false" ? /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-med",
    style: {
      fontSize: "1rem"
    }
  }, "(Estimated Monthly Payment)") : null, /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource == "NET007" ? "Get Quote" : "Apply Now")))) : null) : null, va15A || va30A ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    as: _reactBootstrap.Row,
    className: showVARates ? "d-flex justify-content-center convRates" : "d-none",
    eventKey: "va",
    title: "VA"
  }, va15A.match === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: va15A.rate === va15A.apr || va15A.apr == 0 || va15A.apr - va15A.rate <= 0.01 ? 3 : 5,
    className: "textBlue poppins-black text-center mb-3 mb-sm-3 mb-lg-0 pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_va15A",
    leadSource: themeLeadSource,
    data: va15A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "15 YR FIXED"), va15A.rate === va15A.apr || va15A.apr == 0 || va15A.apr - va15A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: va15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: va15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: va15A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-med pt-0",
    style: {
      fontSize: "1rem"
    }
  }, "(Rate", " ", va15A.rate === va15A.apr || va15A.apr == 0 || va15A.apr - va15A.rate <= 0.01 ? "&" : "/", " ", "APR)"), userSession.getNoClosingCosts() == "true" ? null : /*#__PURE__*/_react.default.createElement("h4", {
    className: va15A.PI > 0 ? "textBlue poppins-black" : "d-none"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: va15A.PI,
    displayType: "text",
    prefix: "$",
    decimalScale: 2,
    thousandSeparator: true,
    fixedDecimalScale: true
  }))), va15A.PI > 0 && userSession.getNoClosingCosts() == "false" ? /*#__PURE__*/_react.default.createElement("h4", {
    style: {
      fontSize: "1rem"
    }
  }, "(Estimated Monthly Payment)") : null, /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource == "NET007" ? "Get Quote" : "Apply Now")))) : null, va30A.match === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: va30A.rate === va30A.apr || va30A.apr == 0 || va30A.apr - va30A.rate <= 0.01 ? 3 : 5,
    className: "textBlue poppins-black text-center pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_va30A",
    leadSource: themeLeadSource,
    data: va30A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "30 YR FIXED"), va30A.rate === va30A.apr || va30A.apr == 0 || va30A.apr - va30A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: va30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: va30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: va30A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    thousandSeparator: true,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-med pt-0",
    style: {
      fontSize: "1rem"
    }
  }, "(Rate", " ", va30A.rate === va30A.apr || va30A.apr == 0 || va30A.apr - va30A.rate <= 0.01 ? "&" : "/", " ", "APR)"), userSession.getNoClosingCosts() == "true" ? null : /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-black"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: va30A.PI,
    displayType: "text",
    prefix: "$",
    decimalScale: 2,
    thousandSeparator: true,
    fixedDecimalScale: true
  }))), va30A.PI > 0 && userSession.getNoClosingCosts() == "false" ? /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-med",
    style: {
      fontSize: "1rem"
    }
  }, "(Estimated Monthly Payment)") : null, /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource == "NET007" ? "Get Quote" : "Apply Now")))) : null) : null, (usda15A.match === true || usda30A.match === true) && themeLeadSource !== "TEXAS-TV" && themeLeadSource !== "NET007" ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    as: _reactBootstrap.Row,
    className: showUsdaRates ? "d-flex justify-content-center convRates" : "d-none convRates",
    eventKey: "usda",
    title: "USDA"
  }, usda15A.match === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: usda15A.rate === usda15A.apr || usda15A.apr == 0 || usda15A.apr - usda15A.rate <= 0.01 ? 3 : 5,
    className: "textBlue poppins-black text-center mb-3 mb-sm-3 mb-lg-0 pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_usda15A",
    leadSource: themeLeadSource,
    data: usda15A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "15 YR FIXED"), usda15A.rate === usda15A.apr || usda15A.apr == 0 || usda15A.apr - usda15A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: usda15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: usda15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: usda15A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "fontSizeRateAprText textBlue poppins-med pt-0",
    style: {
      fontSize: "1rem"
    }
  }, "(Rate", " ", usda15A.rate === usda15A.apr || usda15A.apr == 0 || usda15A.apr - usda15A.rate <= 0.01 ? "&" : "/", " ", "APR)"), userSession.getNoClosingCosts() == "true" ? null : /*#__PURE__*/_react.default.createElement("h4", {
    className: usda15A.PI > 0 ? "textBlue poppins-black" : "d-none"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: usda15A.PI,
    displayType: "text",
    prefix: "$",
    thousandSeparator: true,
    decimalScale: 2,
    fixedDecimalScale: true
  }))), usda15A.PI > 0 && userSession.getNoClosingCosts() == "false" ? /*#__PURE__*/_react.default.createElement("h4", {
    style: {
      fontSize: "1rem"
    }
  }, "(Estimated Monthly Payment)") : null, /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource == "NET007" ? "Get Quote" : "Apply Now")))) : null, usda30A.match === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: usda30A.rate === usda30A.apr || usda30A.apr == 0 || usda30A.apr - usda30A.rate <= 0.01 ? 3 : 5,
    className: "textBlue poppins-black text-center pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_usda30A",
    leadSource: themeLeadSource,
    data: usda30A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "30 YR FIXED"), usda30A.rate === usda30A.apr || usda30A.apr == 0 || usda30A.apr - usda30A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: usda30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: usda30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: usda30A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "fontSizeRateAprText textBlue poppins-med pt-0",
    style: {
      fontSize: "1rem"
    }
  }, "(Rate", " ", usda30A.rate === usda30A.apr || usda30A.apr == 0 || usda30A.apr - usda30A.rate <= 0.01 ? "&" : "/", " ", "APR)"), userSession.getNoClosingCosts() == "true" ? null : /*#__PURE__*/_react.default.createElement("h4", {
    className: usda30A.PI > 0 ? "textBlue poppins-black" : "d-none"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: usda30A.PI,
    displayType: "text",
    prefix: "$",
    decimalScale: 2,
    thousandSeparator: true,
    fixedDecimalScale: true
  }))), usda30A.PI > 0 && userSession.getNoClosingCosts() == "false" ? /*#__PURE__*/_react.default.createElement("h4", {
    style: {
      fontSize: "1rem"
    }
  }, "(Estimated Monthly Payment)") : null, /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource == "NET007" ? "Get Quote" : "Apply Now")))) : null) : null, homeEquity2NDTD15A || homeEquity2NDTD30A ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    as: _reactBootstrap.Row,
    className: showHomeEquity2ndTDRates ? "d-flex justify-content-center homeEquityRates" : "d-none homeEquityRates",
    eventKey: "homeEquity",
    title: "Home Equity Closed End Rates"
  }, homeEquity2NDTD15A.match === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: homeEquity2NDTD15A.rate === homeEquity2NDTD15A.apr || homeEquity2NDTD15A.apr == 0 ||
    // noCCProgram === true ||
    homeEquity2NDTD15A.apr - homeEquity2NDTD15A.rate <= 0.01 ? 5 : 5,
    className: "textBlue poppins-black text-center mb-3 mb-sm-3 mb-lg-0 pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_2nd_td15A",
    leadSource: themeLeadSource,
    data: homeEquity2NDTD15A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "15 YR FIXED"), homeEquity2NDTD15A.rate === homeEquity2NDTD15A.apr || homeEquity2NDTD15A.apr == 0 ||
  // noCCProgram === true ||
  homeEquity2NDTD15A.apr - homeEquity2NDTD15A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: homeEquity2NDTD15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: homeEquity2NDTD15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: homeEquity2NDTD15A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-med pt-0",
    style: {
      fontSize: "1rem"
    }
  }, "(Rate", " ", homeEquity2NDTD15A.rate === homeEquity2NDTD15A.apr || homeEquity2NDTD15A.apr == 0 ||
  // noCCProgram === true ||
  homeEquity2NDTD15A.apr - homeEquity2NDTD15A.rate <= 0.01 ? "&" : "/", " ", "APR)"), userSession.getNoClosingCosts() == "true" ? null : /*#__PURE__*/_react.default.createElement("h4", {
    className: homeEquity2NDTD15A.PI > 0 ? "textBlue poppins-black" : "d-none"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: homeEquity2NDTD15A.PI,
    displayType: "text",
    prefix: "$",
    thousandSeparator: true,
    decimalScale: 2,
    fixedDecimalScale: true
  }))), homeEquity2NDTD15A.PI > 0 && userSession.getNoClosingCosts() == "false" ? /*#__PURE__*/_react.default.createElement("h4", {
    style: {
      fontSize: "1rem"
    }
  }, "(Estimated Monthly Payment)") : null, /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource == "NET007" ? "Get Quote" : "Apply Now")))) : null, homeEquity2NDTD30A.match === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: homeEquity2NDTD30A.rate === homeEquity2NDTD30A.apr || homeEquity2NDTD30A.apr == 0 ||
    // noCCProgram === true ||
    homeEquity2NDTD30A.apr - homeEquity2NDTD30A.rate <= 0.01 ? 5 : 5,
    className: "textBlue poppins-black text-center pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_2nd_td30A",
    leadSource: themeLeadSource,
    data: homeEquity2NDTD30A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "30 YR FIXED"), homeEquity2NDTD30A.rate === homeEquity2NDTD30A.apr || homeEquity2NDTD30A.apr == 0 ||
  // noCCProgram === true ||
  homeEquity2NDTD30A.apr - homeEquity2NDTD30A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: homeEquity2NDTD30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: homeEquity2NDTD30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: homeEquity2NDTD30A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-med pt-0",
    style: {
      fontSize: "1rem"
    }
  }, "(Rate", " ", homeEquity2NDTD30A.rate === homeEquity2NDTD30A.apr || homeEquity2NDTD30A.apr == 0 ||
  // noCCProgram === true ||
  homeEquity2NDTD30A.apr - homeEquity2NDTD30A.rate <= 0.01 ? "&" : "/", " ", "APR)"), userSession.getNoClosingCosts() == "true" ? null : /*#__PURE__*/_react.default.createElement("h4", {
    className: homeEquity2NDTD30A.PI > 0 ? "textBlue poppins-black" : "d-none"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: homeEquity2NDTD30A.PI,
    displayType: "text",
    prefix: "$",
    thousandSeparator: true,
    decimalScale: 2,
    fixedDecimalScale: true
  }))), homeEquity2NDTD30A.PI > 0 && userSession.getNoClosingCosts() == "false" ? /*#__PURE__*/_react.default.createElement("h4", {
    style: {
      fontSize: "1rem"
    }
  }, "(Estimated Monthly Payment)") : null, /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource == "NET007" ? "Get Quote" : "Apply Now")))) : null) : null) : null))), /*#__PURE__*/_react.default.createElement("span", {
    ref: myRefRD
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "d-flex justify-content-center"
  }, !loading && productsList.length !== 0 ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 12
  }, /*#__PURE__*/_react.default.createElement("hr", null)) : null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: "10",
    md: "8",
    className: "mt-1 ratesTitle text-center mainBody",
    style: {
      color: "rgb(14, 62, 155)"
    }
  }, /*#__PURE__*/_react.default.createElement("h6", {
    className: "mb-0"
  }, "Rates are subject to change without notice. Not all applicants will qualify. Interest Rate and APR are estimates as of\xA0", shortDate, ".")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 12
  }, /*#__PURE__*/_react.default.createElement("hr", null)))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: !loading && countyName ? "d-flex justify-content-center" : "d-none"
  }, /*#__PURE__*/_react.default.createElement("span", {
    ref: myRefRD
  }), !loading && productsList.length === 0 ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 10
  }, /*#__PURE__*/_react.default.createElement("h4", null, "We are in the middle of updating today's rates. Please check back in 15 minutes or you can call us at", " ", /*#__PURE__*/_react.default.createElement("a", {
    href: "tel:+18445625337",
    className: "text-decoration-none ratesatagnewchanges"
  }, "844-562-5337"), " ", "for immediate assistance.")) : "", !loading && productsList.length !== 0 ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 12
  }, /*#__PURE__*/_react.default.createElement("h5", null, "The above rate quote was based on the following:")) : "", /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 6,
    className: "mt-1 mb-2"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Table, {
    responsive: "sm",
    bordered: true,
    hover: false,
    className: " mb-0 text-center textBlue"
  }, /*#__PURE__*/_react.default.createElement("tbody", null, loanTypeName ? /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
    className: "textBlue poppins-med"
  }, /*#__PURE__*/_react.default.createElement("h5", null, "Loan Purpose")), /*#__PURE__*/_react.default.createElement("td", null, loanTypeName)) : null, userSession.getPurchasePrice() > 0 ? /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
    className: "textBlue poppins-med"
  }, /*#__PURE__*/_react.default.createElement("h5", null, "Purchase Price")), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: userSession.getPurchasePrice(),
    displayType: "text",
    thousandSeparator: true,
    prefix: "$",
    decimalScale: 0,
    fixedDecimalScale: false
  }))) : null, userSession.getDownPaymentAmount() > 0 ? /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
    className: "textBlue poppins-med"
  }, /*#__PURE__*/_react.default.createElement("h5", null, "Down Payment")), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: userSession.getDownPaymentAmount(),
    displayType: "text",
    thousandSeparator: true,
    prefix: "$",
    decimalScale: 0,
    fixedDecimalScale: false
  }))) : null, userSession.getCurrentLoanBalance() > 0 ? /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
    className: "textBlue poppins-med"
  }, /*#__PURE__*/_react.default.createElement("h5", null, "Current Loan Balance")), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: userSession.getCurrentLoanBalance(),
    displayType: "text",
    thousandSeparator: true,
    prefix: "$",
    decimalScale: 0,
    fixedDecimalScale: false
  }))) : null, userSession.getCashOutAmount() > 0 ? /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
    className: "textBlue poppins-med"
  }, /*#__PURE__*/_react.default.createElement("h5", null, "Cash Out Amount")), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: userSession.getCashOutAmount(),
    displayType: "text",
    thousandSeparator: true,
    prefix: "$",
    decimalScale: 0,
    fixedDecimalScale: false
  }))) : null, userSession.getEstimatedValue() > 0 ? /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
    className: "textBlue poppins-med"
  }, /*#__PURE__*/_react.default.createElement("h5", null, "Estimated Home Value")), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: userSession.getEstimatedValue(),
    displayType: "text",
    thousandSeparator: true,
    prefix: "$",
    decimalScale: 0,
    fixedDecimalScale: false
  }))) : null, ltv ? /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
    className: "textBlue poppins-med"
  }, /*#__PURE__*/_react.default.createElement("h5", null, "Loan to Value")), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: ltv * 100,
    displayType: "text",
    thousandSeparator: false,
    suffix: "%",
    decimalScale: 0,
    fixedDecimalScale: false
  }))) : null, userSession.getPropertyZipCode() ? /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
    className: "textBlue poppins-med"
  }, /*#__PURE__*/_react.default.createElement("h5", null, "Property ZipCode")), /*#__PURE__*/_react.default.createElement("td", null, userSession.getPropertyZipCode())) : null, userSession.getPropertyCounty() ? /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
    className: "textBlue poppins-med"
  }, /*#__PURE__*/_react.default.createElement("h5", null, "Property County")), /*#__PURE__*/_react.default.createElement("td", null, countyName)) : null, userSession.getPropertyState() ? /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
    className: "textBlue poppins-med"
  }, /*#__PURE__*/_react.default.createElement("h5", null, "Property State")), /*#__PURE__*/_react.default.createElement("td", null, userSession.getPropertyState())) : null, userSession.getCreditScore() ? /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
    className: "textBlue poppins-med"
  }, /*#__PURE__*/_react.default.createElement("h5", null, "Credit Score")), /*#__PURE__*/_react.default.createElement("td", null, userSession.getCreditScore())) : null, propTypeName ? /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
    className: "textBlue poppins-med"
  }, /*#__PURE__*/_react.default.createElement("h5", null, "Property Type")), /*#__PURE__*/_react.default.createElement("td", null, propTypeName)) : null, propUsed ? /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
    className: "textBlue poppins-med"
  }, /*#__PURE__*/_react.default.createElement("h5", null, "Property Used")), /*#__PURE__*/_react.default.createElement("td", null, propUsed)) : null, userSession.getVeteran() ? /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
    className: "textBlue poppins-med"
  }, /*#__PURE__*/_react.default.createElement("h5", null, "Are You a Veteran?")), /*#__PURE__*/_react.default.createElement("td", null, userSession.getVeteran() == "true" ? "Yes" : "No")) : null, userSession.getNoClosingCosts() == "true" ? /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
    className: "textBlue poppins-med"
  }, /*#__PURE__*/_react.default.createElement("h5", null, "No Closing Costs")), /*#__PURE__*/_react.default.createElement("td", null, userSession.getNoClosingCosts() == "true" ? "Yes" : "No")) : null, userSession.getNoClosingCosts() == "false" ? /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
    className: "textBlue poppins-med"
  }, /*#__PURE__*/_react.default.createElement("h5", null, "Lower Monthly Payment")), /*#__PURE__*/_react.default.createElement("td", null, userSession.getNoClosingCosts() == "false" ? "Yes" : "No")) : null, themeLeadSource == "TEXAS-TV" ? /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
    className: "textBlue poppins-med"
  }, /*#__PURE__*/_react.default.createElement("h5", null, "Subordinate Financing")), /*#__PURE__*/_react.default.createElement("td", null, "No")) : null))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 12
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    className: "cyanButton",
    onClick: () => props.jumpToStep(0)
  }, "Change Quote"))));
}